define('views/transfer/transfer_to_option',[
    'backbone',
    'views/_base/baseview',
    'text!views/transfer/transfer_to_option.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
		tagName  : 'li',
		className: 'transfer-to-option',
		isRender : true,
		template : _.template(Template),
		events   : {
			'click': 'callParentView'
		},
        initialize: function(options){
			options = options || {};

			this.account = options.account;
			this.account_content = '';
			this.rule = options.rule;
			this.parent_view = options.parent_view;

			this.setContent();

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
        },

		render: function(){

			if(this.account){
				this.$el.data('account-id', this.account.account_id).data('entity-id', this.account.entity_type_id).html(this.template());
			} else if(this.rule.to_entity_type_id == enums.entityTypeEnum.Consumer){
				this.$el.addClass('friends-and-family-trigger').html(this.template());
			}

			
			
			return this;
		},

		setContent: function(){
			var rule_entity_id = this.rule.to_entity_type_id;

			// Check to see if Friends or Family
			if(rule_entity_id == enums.entityTypeEnum.Consumer){
				this.account_content = 'Send to Friends or Family';
			}

			// Check to see if Bank Account
			if(rule_entity_id == enums.entityTypeEnum.ExternalBank){
				this.account_content = this.account.account_name;
			}

			// Check to see if an account
			if(rule_entity_id == enums.entityTypeEnum.Account){
				this.account_content = this.account.account_name + ' (' + formatBalanceCurrency(this.account.balance) + ')';
			}

			// Lastly check to see if a spending account
			if(rule_entity_id == enums.entityTypeEnum.SpendingAccount){
				this.account_content = 'PayForward Account (' + formatBalanceCurrency(this.account.balance) + ')';
			}
			
		},

		callParentView: function(e){
			if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            if(!this.account && this.rule.to_entity_type_id == enums.entityTypeEnum.Consumer){

            	// Call parent view to show friends and family
            	this.parent_view.showFriendsAndFamily();

            } else {

            	// Update Transfer object
	            this.parent_view.transfer.to = {
	            	account_id 	  : this.account.account_id,
	            	entity_type_id: this.account.entity_type_id
	            };

	            if(this.rule.to_entity_type_id == enums.entityTypeEnum.SpendingAccount){
	            	var name = 'PayForward Account (' + formatBalanceCurrency(this.account.balance) + ')';
	            } else {
	            	var name = this.account.account_name;
	            }

	            // Call parent view to reset and show selected To option
            	this.parent_view.handleTransferToSelection(name);

            }
            
		}
		
    });
});

